<p-table #dt [columns]="cols" [value]="items" styleClass="p-datatable-responsive-demo p-datatable-striped"
         [scrollable]="true" scrollHeight="90vh" [style]="width" [exportFilename]="name">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let col of columns; index as i">
        <th *ngIf="i==0" style="{{column1Width}}">
          <div>
            {{col.header}}
          </div>
        </th>
        <th *ngIf="i > 0">
          <div [ngClass]="{'right-align': col.field != 'checkpoint'}">
            {{col.header}}
          </div>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-columns="columns">
    <tr>
      <ng-container *ngFor="let col of columns; index as i">
        <td *ngIf="i==0" style="{{column1Width}}">
          <div>
            <span class="p-column-title">{{col.header}}</span>
            <b>{{item[col.field]}}</b>
          </div>
        </td>
        <td *ngIf="i > 0">
          <div [ngClass]="{'right-align': col.field != 'checkpoint'}">
            <span class="p-column-title">{{col.header}}</span>
            {{item[col.field] | cell}}
          </div>
        </td>
      </ng-container>
    </tr>
  </ng-template>
</p-table>
